export type ToolCallInvocation = {
  id: string;
  role: 'tool_call_invocation';
  name: string;
  arguments: string;
};

export type ToolCallResult = {
  id: string;
  role: 'tool_call_result';
  content: string;
};

export type Message = {
  role: 'user' | 'agent';
  content: string;
  words: {
    word: string;
    start: number;
    end: number;
  }[];
};

export type TranscriptItem = Message | ToolCallInvocation | ToolCallResult;

export function isToolCallInvocation(item: TranscriptItem): item is ToolCallInvocation {
  return item.role === 'tool_call_invocation';
}

export function isToolCallResult(item: TranscriptItem): item is ToolCallResult {
  return item.role === 'tool_call_result';
}

export function isTool(item: TranscriptItem): item is ToolCallInvocation | ToolCallResult {
  return isToolCallInvocation(item) || isToolCallResult(item);
}

export function isMessageItem(item: TranscriptItem): item is Message {
  return item.role === 'user' || item.role === 'agent';
}
